import { useQuery } from '@tanstack/react-query';
import { fxRatesService } from '@/services/fx-rates/fx-rates-service';
import { queryKeys } from '@/services/query-keys';

/**
 * LR-493: COB (T-1) EUR-based FX rates for the settlement majors, the source for the MTM /
 * margin-call DISPLAY equivalents. The COB target rolls forward at UTC midnight and the backend
 * caches per-symbol until then, so a long staleTime is fine.
 */
export const useCobFxRates = () => {
  return useQuery({
    queryKey: queryKeys.fxRates.cob,
    queryFn: () => fxRatesService.getCobRates(),
    staleTime: 60 * 60 * 1000, // 1h — COB only changes at the daily rollover
    retry: 2,
    refetchOnWindowFocus: false,
  });
};
